var _a;
import { ActionObjectType, DataResidency, HubNames, SecondaryM365ContentIdName, Themes, } from '@metaos/hub-sdk';
import { useCapabilities } from '@office-start/capabilities-service';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useIdentity } from '@office-start/identity-service';
import { useThemeMode } from '@office-start/theming-service';
import { OfficeThemeMode } from '@office-start/theming-types';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import { useMemo } from 'react';
import { GetLocaleInfo, hostClientType, } from '../appContextUtils';
function useMySitePath() {
    var _a;
    var userEntitlements = useUserEntitlements().data;
    var OneDriveUrl = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.OneDriveUrl;
    return useMemo(function () {
        try {
            var url = new URL(OneDriveUrl || '');
            return url.pathname;
        }
        catch (_exeption) {
            return undefined;
        }
    }, [OneDriveUrl]);
}
/**
 * Translate between OfficeThemeMode and hub-sdk theme
 */
var OfficeHomeThemeToHubSdkTheme = (_a = {},
    _a[OfficeThemeMode.dark] = Themes.dark,
    _a[OfficeThemeMode.default] = Themes.default,
    _a[OfficeThemeMode.highContrast] = Themes.highContrast,
    _a);
export function useAppHostContext(params) {
    var _a, _b;
    var officeComponentContext = useOfficeComponentContext().data;
    var officeIdentity = useIdentity().data;
    var capabilities = useCapabilities().data;
    var theme = OfficeHomeThemeToHubSdkTheme[useThemeMode() || OfficeThemeMode.default];
    var additionalParams = params.additionalParams;
    var userEntitlements = useUserEntitlements().data;
    var sharePointResourceId = (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.SharePointResourceId;
    var mySiteDomainResourceId = (_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.OneDriveResourceId;
    var mySitePath = useMySitePath();
    return useMemo(function () {
        if (!officeComponentContext || !officeIdentity || !params.appId) {
            return undefined;
        }
        return {
            app: {
                host: {
                    clientType: hostClientType,
                    name: HubNames.office,
                    ringId: params.ringId,
                    sessionId: officeComponentContext.sessionId,
                    version: officeComponentContext.buildVersion,
                },
                iconPositionVertical: params.iconPositionVertical,
                locale: officeComponentContext.preferredCulture,
                osLocaleInfo: GetLocaleInfo(officeComponentContext.preferredCulture),
                sessionId: params.appHostSessionId,
                theme: theme,
                userClickTime: params.userClickTime,
            },
            page: {
                frameContext: params.frameContext,
                id: params.entityId,
                isFullScreen: params.isFullScreen,
                isMultiWindow: false,
                subPageId: params.appId === 'apps' &&
                    !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.sharedServicesEnabled)
                    ? JSON.stringify({
                        supportedElementInfo: {
                            staticTabs: [
                                {
                                    scopes: ['personal'],
                                },
                            ],
                        },
                    })
                    : params.subPageId,
                sourceOrigin: officeComponentContext.officeHomeApiRoot, //TODO
            },
            user: {
                tenant: {
                    id: officeIdentity.tenantId,
                    sku: undefined, //TODO
                },
                licenseType: undefined,
                dataResidency: officeComponentContext.dataBoundary === 'EU'
                    ? DataResidency.EUDB
                    : DataResidency.Public,
            },
            sharePointSite: !!sharePointResourceId && !!mySiteDomainResourceId
                ? {
                    teamSiteDomain: sharePointResourceId.replace(/^https?:\/\//, ''),
                    teamSitePath: '',
                    mySiteDomain: mySiteDomainResourceId.replace(/^https?:\/\//, ''),
                    mySitePath: mySitePath,
                }
                : undefined,
            actionInfo: additionalParams && additionalParams['actionId']
                ? {
                    actionId: additionalParams['actionId'],
                    actionObjects: [
                        {
                            type: ActionObjectType.M365Content,
                            itemId: additionalParams['itemId'],
                            secondaryId: {
                                name: SecondaryM365ContentIdName.DriveId,
                                value: additionalParams[SecondaryM365ContentIdName.DriveId],
                            },
                        },
                    ],
                }
                : undefined,
        };
    }, [
        additionalParams,
        capabilities === null || capabilities === void 0 ? void 0 : capabilities.sharedServicesEnabled,
        mySiteDomainResourceId,
        officeComponentContext,
        officeIdentity,
        params.appHostSessionId,
        params.appId,
        params.entityId,
        params.frameContext,
        params.iconPositionVertical,
        params.isFullScreen,
        params.ringId,
        params.subPageId,
        params.userClickTime,
        sharePointResourceId,
        theme,
    ]);
}
//# sourceMappingURL=useAppHostContext.js.map